import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router';
import useLocales from 'hooks/useLocales';
import Image from 'components/image/Image';
import Button from 'components/Button/Index';
import { JobService } from 'services/jobs/job';
import { COMPANY_ROUTES } from 'core/constants/companyRoutes';

import './index.scss';

const MatchResultHeader = ({ data }: any): JSX.Element => {
  const navigate = useNavigate();
  const location = useLocation();
  const { type } = useParams<{ type?: string }>();
  const { t } = useLocales();
  const [selectedLabels, setSelectedLabels] = useState<string[]>([]);
  const [ids, setIds] = useState<string[]>([]);

  const resolveLocationLabel = async (): Promise<string> => {
    const firstLocation = data?.locations?.[0];
    if (!firstLocation) {
      return '';
    }

    if (
      typeof firstLocation === 'object' &&
      'display_name' in firstLocation &&
      firstLocation.display_name
    ) {
      return firstLocation.display_name;
    }

    const locationId =
      typeof firstLocation === 'object' && 'id' in firstLocation
        ? firstLocation.id
        : firstLocation;
    const location = await JobService.getLocationById(locationId);
    return location?.display_name || '';
  };

  const handleNext = async () => {
    let info;
    if (selectedLabels.length >= 7 && selectedLabels.length <= 10) {
      const idLabelArray = ids.map((id, index) => ({
        id,
        competency: selectedLabels[index]
      }));
      const locationLabel = await resolveLocationLabel();
      if (data.is_culture !== undefined) {
        info = {
          job_title: data?.title,
          culture_profile: data?.culture_profile,
          competencies: idLabelArray,
          is_culture: false,
          edit: data ? data?.id : false,
          scores: data?.competency_min_scores
        };
      } else {
        info = {
          skills: data?.skills,
          culture_profile: data?.culture_profile,
          degree: data?.degree,
          industries: data?.industries,
          is_public: data?.is_public,
          job_description: data?.description,
          job_title: data?.title,
          location: locationLabel,
          prefered_salary: data?.salary,
          required_experience: data?.work_exp,
          musts: data?.musts,
          scores: data?.competency_min_scores,
          competencies: idLabelArray,
          edit: data ? data?.id : false,
          is_remote: data?.is_remote,
          if_office_work: data?.if_office_work,
          status: data?.status,
          contract_type: data?.contract,
          hourly_rate: data?.hourly_rate
        };
      }
      navigate('/company/culture');

      localStorage.setItem('selected', JSON.stringify(info));
    }
  };

  useEffect(() => {
    if (data) {
      setSelectedLabels(data?.competency_labels);
      const a = data?.competencies?.map((e: any) => e?.competency?.id);
      setIds(a);
    }
  }, [data]);

  const getFallbackRoute = (): string => {
    if (location.pathname.includes('/company/find-candidate/')) {
      return COMPANY_ROUTES.JOB_POSTS;
    }
    if (type === 'job-posts') {
      return COMPANY_ROUTES.JOB_POSTS;
    }
    return COMPANY_ROUTES.FIND_CANDIDATES;
  };

  const handleBack = (): void => {
    if (window.history.length > 1) {
      navigate(-1);
      return;
    }
    navigate(getFallbackRoute());
  };

  return (
    <div className="result-header">
      <div
        className="back_button skillio-back-button"
        onClick={handleBack}
      >
        <Image name="arrow-left.svg" />
        {t('Back')}
      </div>
      <div className="match-settings">
        <div className="top">
          <div className="match-settings-text">
            <p className="title">{t('Requested competencies')}</p>
            <span className="text">{data?.title}</span>
          </div>
          <Button
            onClick={handleNext}
            title={t('Edit')}
            type="button"
            t={t}
            className="edit-mach"
          />
        </div>
        <div className="bottom">
          {data?.competencies?.map((e: any) => (
            <div key={e.text} className="settings-item">
              {e?.competency?.name} ({e?.min_score} - 9)
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default MatchResultHeader;
